import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useUserStore } from '../../stores/userStore';

const CompletedAssessments = () => {
	const { user } = useUserStore();
	const completedAssessmentsQuery = useQuery({
		queryKey: ['completedAssessments', user.id],
		queryFn: async () => {
			const { data } = await axios.get(
				`/clients/${user.id}/completed-assessments`,
			);
			return data;
		},
	});
	return (
		<div className="application page-wide">
			<h1>Questionnaires</h1>
			<p className="mb-4">
				Below is a list of completed Questionnaires. You can open each to review
				or update.
			</p>
			{completedAssessmentsQuery.isLoading && (
				<div className="text-center">
					<span className="loading loading-dots loading-lg text-primary"></span>
				</div>
			)}
			{!completedAssessmentsQuery.isLoading &&
				completedAssessmentsQuery.data.length === 0 && (
					<div>No completed questionnaires found.</div>
				)}
			<div className="grid gap-4 sm:grid-cols-3">
				{!completedAssessmentsQuery.isLoading &&
					completedAssessmentsQuery.data.map((assessment) => (
						<div key={assessment.id} className="bg-white shadow card">
							<div className="card-body">
								<h3 className="card-title">{assessment.name}</h3>
								<p className="card-text">
									Completed on:{' '}
									{new Date(assessment.response_dttm).toLocaleDateString()}
								</p>
								<Link
									to={`/assessments/${assessment.id}`}
									className="btn btn-primary"
								>
									View / Update
								</Link>
							</div>
						</div>
					))}
			</div>
		</div>
	);
};

export default CompletedAssessments;
